import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Lock, ArrowLeft, ShieldCheck } from "lucide-react";
import Btn from "../components/Btn";
import ThemeToggle from "../components/ThemeToggle";
import api, { apiErr } from "../lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) return toast.error("Password minimal 6 karakter.");
    if (pw !== pw2) return toast.error("Konfirmasi password tidak cocok.");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      toast.success("Password berhasil diubah! Silakan masuk.");
      nav("/auth", { replace: true });
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-su-bg flex flex-col">
      <div className="p-4 flex items-center justify-between">
        <Link to="/auth" data-testid="reset-back" className="flex items-center gap-2 font-heading font-extrabold text-su-muted hover:text-su-text">
          <ArrowLeft className="w-5 h-5" /> Masuk
        </Link>
        <ThemeToggle />
      </div>
      <div className="flex-1 grid place-items-center px-4 pb-10">
        <div className="w-full max-w-md">
          <div className="card-chunky p-6 sm:p-8 animate-pop" data-testid="reset-card">
            {!token ? (
              <div className="text-center">
                <h1 className="font-heading font-black text-2xl text-su-text mb-2">Tautan Tidak Valid</h1>
                <p className="text-su-muted font-medium text-sm mb-6">Tautan reset tidak lengkap. Minta tautan baru dari halaman lupa password.</p>
                <Link to="/forgot-password"><Btn className="w-full" data-testid="reset-request-new">Minta Tautan Baru</Btn></Link>
              </div>
            ) : (
              <>
                <div className="w-12 h-12 rounded-2xl bg-su-primary/20 grid place-items-center mb-4">
                  <ShieldCheck className="w-6 h-6 text-su-primary" />
                </div>
                <h1 className="font-heading font-black text-2xl text-su-text mb-1">Buat Password Baru</h1>
                <p className="text-su-muted font-medium text-sm mb-6">Pilih password baru yang kuat untuk akunmu.</p>
                <form onSubmit={submit} className="space-y-3">
                  <PwField testid="reset-password" placeholder="Password baru" value={pw} onChange={setPw} />
                  <PwField testid="reset-password2" placeholder="Ulangi password baru" value={pw2} onChange={setPw2} />
                  <Btn data-testid="reset-submit" type="submit" disabled={busy} className="w-full mt-2">
                    {busy ? "Menyimpan..." : "Simpan Password"}
                  </Btn>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function PwField({ testid, placeholder, value, onChange }) {
  return (
    <div className="relative">
      <Lock className="w-5 h-5 text-su-muted absolute left-4 top-1/2 -translate-y-1/2" />
      <input
        data-testid={testid}
        type="password"
        placeholder={placeholder}
        value={value}
        required
        onChange={(e) => onChange(e.target.value)}
        className="w-full pl-12 pr-4 py-3 rounded-2xl border-2 border-su-border bg-su-bg text-su-text font-medium outline-none focus:border-su-primary transition-colors"
      />
    </div>
  );
}
